export const getRoutePermissions = () => ({
  '/dashboard': null,
  '/products': 'products.view',
  '/products/create': 'products.create',
  '/products/update': 'products.edit',
  '/products/stock': 'products.stock',
  '/variants': 'variants.view',
  '/variants/create': 'variants.create',
  '/variants/update': 'variants.edit',
  '/invoices': 'invoices.view',
  '/invoices/create': 'invoices.create',
  '/clients': 'clients.view',
  '/charges': 'charges.view',
  '/charges/create': 'charges.create',
  '/charges/update': 'charges.edit',
  '/activity-logs': 'activity_logs.view',
  '/users': 'users.manage',
  '/roles': 'roles.manage',
})

export function hasRouteAccess(pathname, can) {
  if (!can) return false

  const normalizedPath = pathname.endsWith('/') && pathname !== '/'
    ? pathname.slice(0, -1)
    : pathname

  const permissions = getRoutePermissions()

  if (permissions[normalizedPath] !== undefined) {
    return permissions[normalizedPath] === null ? true : can(permissions[normalizedPath])
  }

  const sortedRoutes = Object.keys(permissions).sort((a, b) => b.length - a.length)

  for (const route of sortedRoutes) {
    if (normalizedPath === route || normalizedPath.startsWith(route + '/')) {
      return permissions[route] === null ? true : can(permissions[route])
    }
  }

  return true
}
